import { Box, Container, Grid, Typography } from "@mui/material";
import { InstitucionalPalette, themePalette } from "../../config/theme.config";
import CardIcono from "../../common/CardIcon";
import PlantillasIcon from '../../assets/img/plantillas_section.svg';
import CampaniasIcon from '../../assets/img/campanias_section.svg';

const iconos = [
    {
        icon: 'mdi:diary',
        texto: "Aprobar",
        backColor: InstitucionalPalette.PRIMARY,
        backColorDeshabilitado: "#C4C3C3",
        enlace: "/reviewer/aprobacion",
        habilitar: true
    },
    {
        icon: '',
        texto: "Plantillas",
        backColor: InstitucionalPalette.PRIMARY,
        backColorDeshabilitado: "#C4C3C3",
        enlace: "/reviewer/plantillas",
        habilitar: true,
        imagen: PlantillasIcon
    },
    {
        icon: '',
        texto: "Campañas",
        backColor: InstitucionalPalette.PRIMARY,
        backColorDeshabilitado: "#C4C3C3",
        enlace: "/reviewer/campanias",
        habilitar: true,
        imagen: CampaniasIcon
    },
    {
        icon: 'bi:gear',
        texto: "Configuración",
        backColor: InstitucionalPalette.PRIMARY,
        backColorDeshabilitado: "#C4C3C3",
        enlace: "/reviewer/config",
        habilitar: true
    }
]

export const RevisorPage: React.FC<{}> = () => {
    return (
        <Container maxWidth="lg" style={{ padding: '20px', textAlign: 'center', marginTop: 10 }}>
            <Box sx={{ display: 'flex' }}>
                <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: `${themePalette.NAVCOLOR}` }}>
                    Revisor de contenido
                </Typography>
            </Box>
            <Box sx={{ m: 1 }}>
                <Grid className='centrado_centro' container spacing={{ xs: 3, md: 6 }} columns={{ xs: 1, sm: 2, md: 4 }}>
                    {
                        iconos.map(icono => (
                            <Grid item key={icono.texto}>
                                <CardIcono
                                    icon={icono.icon}
                                    texto={icono.texto}
                                    backColor={icono.backColor}
                                    enlace={icono.enlace}
                                    habilitar={icono.habilitar}
                                    backColorDeshabilitar={icono.backColorDeshabilitado}
                                />
                            </Grid>
                        ))
                    }
                </Grid>
            </Box>
        </Container>
    );
}